import React from "react"
import imgOurTeam1 from '../../../assets/imgOurTeam1.png';
import imgOurTeam2 from '../../../assets/imgOurTeam2.png';
import './ourTeam.css';
import { useSelector} from 'react-redux'
import { useState,useEffect } from "react";

  function OurTeam() {
    let boolean = useSelector((state) => state.boolean.bool)
    let [texte,setTexte]=useState()
    let [titre,setTitre]=useState()

    useEffect(() => {
      // Update the document title using the browser API
      if(boolean===false){
        setTexte(texteFR)
        setTitre(titreFR)
     }
     else{
      setTexte(texteANG)
      setTitre(titreENG)
     }
     console.log(texte)
    });

    //le textes en deux langues
    let texteFR="Notre équipe est composée de professionnels de l'intégration audiovisuelle avec des compétences variées et une solide expérience. Nous maîtrisons les technologies actuelles et pouvons analyser clairement votre projet pour assurer une bonne cohérence de la conception à la réalisation. Nous travaillons avec des clients locaux et internationaux et proposons des solutions adaptées à votre budget et à votre calendrier. Nous réalisons des installations audiovisuelles qui répondent à vos objectifs, quelle que soit la taille du projet. Nous collaborons étroitement avec vous pour livrer un résultat conforme aux attentes. Contactez-nous pour parler de votre prochain projet.";
    let texteANG="Our team is composed of audiovisual integration professionals with varied skills and solid experience. We master current technologies and can clearly analyse your project to ensure good consistency from design to implementation. We work with local and international clients and offer solutions tailored to your budget and schedule. We deliver audiovisual installations that meet your objectives, regardless of project size. We collaborate closely with you to deliver a result that meets expectations. Contact us to discuss your next project.";

    let titreFR= "Une expertise de confiance"
    let titreENG= "Expertise You Can Trust"

    return (
      <section className="ourTeamSection">

        <div className="ourTeamGlobalDiv">
          
          <h3 className="ourTeamTitle">{titre}</h3>
          <div className="ourTeam-div">
            
            <div className="ourTeamImg">
              <img src={imgOurTeam1} className="imgOurTeam" alt="" />
              <img src={imgOurTeam2} className="imgOurTeam" alt="" />
            </div>
            <div className="ourTeamText">
              <p>{texte}</p>
            </div>
          </div>

        </div>
        
      </section>
    )
  }

  export default OurTeam;
